import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /**
   * Can be plain text or other Text components
   */
  children: PropTypes.node.isRequired,
  /**
   * Sets the heading level. If set, the component will render as a heading element
   */
  headingLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  /**
   * Sets related typographical styles at once
   */
  typeStyle: PropTypes.string
};
function Text(_ref) {
  var children = _ref.children,
    headingLevel = _ref.headingLevel,
    _ref$typeStyle = _ref.typeStyle,
    typeStyle = _ref$typeStyle === void 0 ? 'body' : _ref$typeStyle;
  var ElementsByHeadingLevel = {
    1: 'h1',
    2: 'h2',
    3: 'h3',
    4: 'h4',
    5: 'h5',
    6: 'h6'
  };
  var Element = headingLevel ? ElementsByHeadingLevel[headingLevel] : 'span';
  return /*#__PURE__*/React__default.createElement(Element, {
    className: "text",
    "data-type-style": typeStyle
  }, children);
}
Text.propTypes = propTypes;

export { Text as default };
//# sourceMappingURL=Text.js.map
